"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  settings: {
    mimeType: 'application/ld+json',
    corsEnabled: false
  },
  environments: {
    staging: 'https://content.staging-api.immediate.co.uk',
    preproduction: 'https://content.preproduction-api.immediate.co.uk',
    production: 'https://content.api.immediate.co.uk'
  },
  endpoints: {
    recipes: {
      endpoint: '/v1/recipes'
    },
    editorialLists: {
      endpoint: '/v1/editorial_lists'
    },
    posts: {
      endpoint: '/v1/posts'
    },
    glossaries: {
      endpoint: '/v1/glossaries'
    },
    howTos: {
      endpoint: '/v1/how_tos'
    },
    plants: {
      endpoint: '/v1/plants'
    },
    reviews: {
      endpoint: '/v1/reviews'
    },
    venues: {
      endpoint: '/v1/venues'
    },
    shows: {
      endpoint: '/v1/broadcast_services_shows'
    },
    pages: {
      endpoint: '/v1/pages'
    },
    liveBlogs: {
      endpoint: '/v1/live_blogs'
    },
    appScreens: {
      endpoint: '/v1/app_screens'
    }
  }
};
exports["default"] = _default;